import React, {useRef} from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
// import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { Link } from "gatsby";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

const drawerWidth = 300;

// function ListItemLink(props) {
//   return <ListItem button component="a" {...props} />;
// }


const useStyles = makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  subheaderstyle: {
    backgroundColor:"#b60011", 
    color:"white", 
    fontSize:"20px",
    fontFamily: "proxima-nova, sans-serif",
  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    color: "#1d1d1b !important",
    textTransform: "capitalize !important",
    borderRadius: "0 !important",  
    fontFamily: "proxima-nova, sans-serif !important",
    fontSize:"18px",
    lineHeight:"20px",
    fontWeight:"600",
    padding:"6px 0",
  
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
      color: "#fff !important"
      }
  },

  menuSettings: {
    backgroundColor: "#EEF0F0",
    textAlign: "left",
    fontWeight: 600,
    borderBottom: "1px solid #7D7D7D",
    padding:"3px 0 3px 24px",
    '@media (max-width: 765px)': {
      paddingLeft: "17px",
    },
  },

  drawerPaper: {
    width: drawerWidth,
  },
  closeButton: {
    fontFamily: "proxima-nova, sans-serif !important",
    fontSize: "18px",
    marginLeft:"210px", 
    fontWeight:"600", 
    textTransform: "none"
  }
}));

const theme = createTheme({
  overrides: {
    MuiToolbar: {
        regular: {
          fontFamily: "proxima-nova, sans-serif",
          color:"#1d1d1b",
          fontWeight:600,
           minHeight: "0px",
           '@media (min-width: 600px)' : {
            minHeight: "0px",
          }
    },
  }
}
});

const MainMenu = (props, {sticky=false, className, ...rest}) => {
  const ref = useRef()
  const menuClasses = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  var urlPath = "";
  if (typeof window !== 'undefined') {
      urlPath = window.location.pathname;
  }

  
  const menuItems = (anchor) => (
    <div
      className={clsx(menuClasses.list, {
        [menuClasses.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
    >
      <Button onClick={toggleDrawer(anchor, false)} className={menuClasses.closeButton} aria-label="Close menu" disableRipple={true}>Close <FontAwesomeIcon style={{marginLeft:"10px", fontSize:"17px"}} icon={faTimes}  /></Button>
      <List
      subheader={
        <ListSubheader className={menuClasses.subheaderstyle} component="div" id="nested-list-subheader">
          Forecasts and warnings 
        </ListSubheader>
      }
      >
        <ListItem style={urlPath === '/' ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="ersey" component={Link} disableRipple={true} to="/" >
          <ListItemText primary="Jersey weather" />
        </ListItem>
        <ListItem style={(urlPath === '/weather/guernsey-forecast' || urlPath === '/weather/guernsey-forecast/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Guernsey forecast" component={Link} disableRipple={true} to="/guernsey-forecast" >
          <ListItemText primary="Guernsey weather" />
        </ListItem>
        <ListItem style={(urlPath === '/weather/aviation' || urlPath === '/weather/aviation/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Aviation forecast" component={Link} disableRipple={true} to="/aviation" >
          <ListItemText primary="Aviation forecast TAFs and METARs" />
        </ListItem>
        <ListItem style={(urlPath === '/weather/shipping' || urlPath === '/weather/shipping/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Shipping forecast" component={Link} disableRipple={true} to="/shipping" >
          <ListItemText primary="Shipping forecast" />
        </ListItem>
        <ListItem style={(urlPath === '/weather/ciweatherwarnings' || urlPath === '/weather/ciweatherwarnings/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="CI weather warnings" component={Link} disableRipple={true} to="/ciweatherwarnings" >
          <ListItemText  primary="CI weather warnings" />
        </ListItem>
      </List>
    
      <List
      subheader={
        <ListSubheader className={menuClasses.subheaderstyle} component="div" id="nested-list-subheader">
          Live updates
        </ListSubheader>
      }
      >
        <ListItem style={(urlPath === '/weather/radar' || urlPath === '/radar/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}} button key="CI weather radar" component={Link} disableRipple={true} to="/radar" >
          <ListItemText primary="CI weather radar"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/liveweatherobservations' || urlPath === '/liveweatherobservations/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Weather observations" component={Link} disableRipple={true} to="/liveweatherobservations" >
          <ListItemText primary="Weather observations"/>
        </ListItem>
        <a href="https://www.gov.je/environment/protectingenvironment/air/pages/airquality.aspx" target="_blank" rel="noreferrer" style={{color:"#1d1d1b", fontSize:"18px", textDecoration:"none"}}>
        <ListItem key="Jersey air quality">
          <ListItemText primary="Jersey air quality"/>
        </ListItem>
        </a>
        <ListItem style={(urlPath === '/weather/runwaywebcam' || urlPath === '/weather/runwaywebcam/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Runway webcam" component={Link} disableRipple={true} to="/runwaywebcam" >
          <ListItemText primary="Runway webcam"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/satellite' || urlPath === '/weather/satellite/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Satellite image" component={Link} disableRipple={true} to="/satellite" >
          <ListItemText primary="Satellite image"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/windandwave' || urlPath === '/weather/windandwave/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Wind and wave map" component={Link} disableRipple={true} to="/windandwave" >
          <ListItemText primary="Wind and wave map"/>
        </ListItem>
      </List>

      <List
      subheader={
        <ListSubheader className={menuClasses.subheaderstyle} component="div" id="nested-list-subheader">
          Tides and sun
        </ListSubheader>
      }
      >
        <ListItem style={(urlPath === '/weather/tidetimes' || urlPath === '/weather/tidetimes/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="St Helier tides" component={Link} disableRipple={true} to="/tidetimes" >
          <ListItemText primary="St Helier tides"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/tidetimes-guernsey' || urlPath === '/weather/tidetimes-guernsey/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="St Peter Port tides" component={Link} disableRipple={true} to="/tidetimes-guernsey" >
          <ListItemText primary="St Peter Port tides"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/sunrisesunset' || urlPath === '/weather/sunrisesunset/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Jersey Airport sunrise and sunset" component={Link} disableRipple={true} to="/sunrisesunset" >
          <ListItemText primary="Jersey Airport sunrise and sunset"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/sunrisesunset-guernsey' || urlPath === '/weather/sunrisesunset-guernsey/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="St Peter Port sunrise and sunset" component={Link} disableRipple={true} to="/sunrisesunset-guernsey" >
          <ListItemText primary="St Peter Port sunrise and sunset"/>
        </ListItem>
      </List>

      <List
        subheader={
          <ListSubheader className={menuClasses.subheaderstyle} component="div" id="nested-list-subheader">
            Related links
          </ListSubheader>
        }
      >
        <ListItem style={(urlPath === '/weather/aboutjerseymet' || urlPath === '/weather/aboutjerseymet/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="About Jersey Met" component={Link} disableRipple={true} to="/aboutjerseymet" >
          <ListItemText primary="About Jersey Met"/>
        </ListItem>
        <a href="https://blog.gov.je/tag/jersey-met/" target="_blank" rel="noreferrer" style={{color:"#1d1d1b", fontSize:"18px", textDecoration:"none"}}>
        <ListItem key="Blog posts">
          <ListItemText primary="Blog posts"/>
        </ListItem>
        </a>
        <ListItem style={(urlPath === '/weather/coastalreports' || urlPath === '/weather/coastalreports/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Coastal reports" component={Link} disableRipple={true} to="/coastalreports" >
          <ListItemText primary="Coastal reports"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/dailyweatherdata' || urlPath === '/weather/dailyweatherdata/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Daily weather data" component={Link} disableRipple={true} to="/dailyweatherdata" >
          <ListItemText primary="Daily weather data"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/earthquakes' || urlPath === '/weather/earthquakes/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Earthquakes" component={Link} disableRipple={true} to="/earthquakes" >
          <ListItemText primary="Earthquakes"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/forecasttimes' || urlPath === '/weather/forecasttimes/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Forecast times" component={Link} disableRipple={true} to="/forecasttimes" >
          <ListItemText primary="Forecast times"/>
        </ListItem>        
        <ListItem style={(urlPath === '/weather/jerseyclimate' || urlPath === '/weather/jerseyclimate/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Jersey climate" component={Link} disableRipple={true} to="/jerseyclimate" >
          <ListItemText primary="Jersey climate"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/services' || urlPath === '/weather/services/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Jersey Met premium services" component={Link} disableRipple={true} to="/services" >
          <ListItemText primary="Jersey Met premium services"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/uvindex' || urlPath === '/weather/uvindex/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="UV index" component={Link} disableRipple={true} to="/uvindex" >
          <ListItemText primary="UV index"/>
        </ListItem>
        <ListItem style={(urlPath === '/weather/weatherdisclaimer' || urlPath === '/weather/weatherdisclaimer/') ? { backgroundColor:"#979797", color:"#1d1d1b", fontSize:"18px"} : { color:"#1d1d1b", fontSize:"18px"}}  button key="Weather disclaimer" component={Link} disableRipple={true} to="/weatherdisclaimer" >
            <ListItemText primary="Weather disclaimer"/>
        </ListItem>         
      </List>
    </div>
  );

  return (
    <>
      {['left'].map((anchor) => (
        <React.Fragment  key={anchor}>
           <ThemeProvider theme={theme}>
          <AppBar id="scrolldown"  ref={ref} {...rest} style={{zIndex:"2"}} className={menuClasses.menuSettings}>
            <Toolbar disableGutters={true}>            
                <Button disableRipple={true} onClick={toggleDrawer(anchor, true)} className={menuClasses.menuButton}><FontAwesomeIcon style={{marginRight:"8px"}}  icon={faBars} />Menu</Button> 
            </Toolbar>
          </AppBar>
          </ThemeProvider>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            // onOpen={toggleDrawer(anchor, true)}
          >
            {menuItems(anchor)}
          </Drawer>
        </React.Fragment>
      ))
      }
    </>
  )
}

export default MainMenu

// className={className + (isSticky && " isSticky")}